import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=29359610&"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports